import { BlitsError } from "./blits.error";

export class FlowError extends BlitsError {

  static CODE = "flow_error";

  constructor(message: string, public readonly blockId?: string) {
    super(FlowError.CODE, message);
  }
}